(() => {
  const media = window.matchMedia('(max-width:749px)');
  const header = document.querySelector('.section-header');
  const gallery = document.querySelector('product-info[data-update-url="true"] .product__media-wrapper');
  if (!header || !gallery || !document.body.classList.contains('az-product-base')) return;
  let queued = false;
  const update = () => {
    queued = false;
    const mobile = media.matches;
    const headerHeight = header.getBoundingClientRect().height;
    document.body.classList.toggle('az-pdp-solid', mobile && gallery.getBoundingClientRect().bottom <= headerHeight);
    document.body.classList.toggle('az-pdp-scrolled', mobile && window.scrollY > 20);
  };
  const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
  window.addEventListener('scroll', schedule, { passive:true });
  window.addEventListener('resize', schedule, { passive:true });
  media.addEventListener('change', schedule);
  new ResizeObserver(schedule).observe(gallery);
  document.addEventListener('shopify:section:load', schedule);
  update();
})();
